<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"
					>{{ shippingDate | dateFormatter }}　{{ componentName }}　出庫個数
				</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark color="white" @click="closeDialog()">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" v-model="valid" lazy-validation>
				<v-combobox
					:items="ordered_products"
					item-text="get_processed_product_number"
					item-value="id"
					:hint="productKeyword.length > 0 ? '検索結果がありません' : '製造番号を入力してください'"
					label="出庫対象製品と製造番号"
					class="mt-4"
					outlined
					dense
					v-model="ordered_product"
					no-data-text="検索結果がありません"
					@keyup="setSearchProduct"
					ref="combobox"
					@change="changeOrderedProduct"
					small-chips
					single
				/>
				<v-text-field
					hint="出庫する部品個数を入力してください"
					label="個数"
					class="mt-4"
					outlined
					dense
					type="number"
					v-model="planned_quantity"
					:readonly="!authorityFlag"
				/>
				<div class="warning" v-if="planned_quantity > total_planned_quantity">
					出庫予定数が在庫数を超えています。
				</div>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4" />
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn
								color="secondary"
								@click="addShippingQuantity(shippingDate)"
								:disabled="!isValid"
							>
								<v-icon class="mr-2">mdi-plus</v-icon>
								登録する
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import moment from "moment"
import "moment/locale/ja"

export default {
	props: {
		component_id: {
			type: Number,
			required: true,
		},
		authorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
	},
	data() {
		return {
			rules: rules,
			dialog: false,
			planned_quantity: "",
			componentName: "",
			shippingDate: "",
			id: "",
			valid: false,
			product: "",
			ordered_product: "",
			ordered_products: [],
			receiving_shipping: {},
			total_planned_quantity: "",
			checkQuantity: false,
			productKeyword: "",
			searchProductTimer: "",
		}
	},

	methods: {
		openDialog(name, date, id, total_planned_quantity) {
			this.dialog = true
			this.componentName = name
			this.id = id
			this.shippingDate = date
			this.total_planned_quantity = total_planned_quantity
		},
		closeDialog() {
			this.dialog = false
			this.$refs.form.reset()
		},

		addShippingQuantity(date) {
			const headers = authenticate.setHeader()
			if (this)
				axios
					.post(
						`/erp/v1/stocks`,
						{
							receiving_shipping: {
								planned_quantity: this.planned_quantity,
								movement_type: "shipping",
								operation_date: date,
								target_id: this.component_id,
							},
							others: {
								ordered_product_id: this.ordered_product?.id,
							},
						},
						{ headers }
					)
					.then((res) => {
						this.closeDialog()
						this.receiving_shipping = res.data.receiving_shipping
						this.$emit("reload-show", this.receiving_shipping)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
		},
		isPresence(value) {
			return value !== null && value !== ""
		},

		changeOrderedProduct() {
			// テキスト追加時の削除
			if (!this.ordered_products.includes(this.ordered_product)) {
				this.ordered_product = null
				this.receiving_shippings = null
				this.$refs.combobox.reset()
			}
		},
		setSearchProduct(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.ordered_products = []
			this.productKeyword = e.target.value
			clearTimeout(this.searchProductTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.productKeyword.length) return // 0文字の場合はreturn
			this.searchProductTimer = setTimeout(this.fetchProducts, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		fetchProducts() {
			const params = {
				q: {
					product_number_cont: this.productKeyword,
					order_components_component_id_eq: this.component_id,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_ordered_products", {
					headers,
					params,
				})
				.then((res) => {
					this.searchProductTimer = null
					this.ordered_products = res.data.ordered_products
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		isValid() {
			if (this.isPresence(this.planned_quantity)) {
				return true
			} else {
				return false
			}
		},
	},

	watch: {
		planned_quantity: function (newVal, oldVal) {
			if (newVal > this.total_planned_quantity) {
				this.checkQuantity = false
			} else {
				this.checkQuantity = true
			}
		},
	},
}
</script>
